createReqData